import React from 'react';
import * as styles from './address.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Address = props => {
  var formatFullAddress = addressModel => {
    var addressLine2 = [addressModel.suburb, addressModel.state, addressModel.postcode].filter(item => item).join(' ');
    var address = [addressModel.street, addressLine2].filter(item => item).join(', ');
    return address;
  };
  var renderLine1 = () => {
    if (!props.street) {
      return false;
    }
    return ___EmotionJSX("div", {
      css: styles.line1
    }, ___EmotionJSX("span", {
      itemProp: "streetAddress"
    }, props.street));
  };
  var renderLine2 = () => {
    if (!(props.suburb || props.state || props.postcode)) {
      return false;
    }
    var line2 = [];
    if (props.suburb) {
      line2.push(___EmotionJSX("span", {
        itemProp: "addressLocality",
        key: "locality"
      }, props.suburb));
    }
    if (props.state) {
      line2.push(___EmotionJSX("span", {
        itemProp: "addressRegion",
        key: "region"
      }, props.state));
    }
    if (props.postcode) {
      line2.push(___EmotionJSX("span", {
        itemProp: "postalCode",
        key: "postcode"
      }, props.postcode));
    }
    var line2Spaced = line2.reduce((prev, curr, index) => {
      if (index === 0) {
        prev.push(curr);
      } else {
        prev.push(' ');
        prev.push(curr);
      }
      return prev;
    }, []);
    return ___EmotionJSX("span", null, line2Spaced);
  };
  return ___EmotionJSX("div", {
    itemScope: true,
    itemProp: "location",
    itemType: "http://schema.org/Residence",
    css: styles.address
  }, ___EmotionJSX("meta", {
    itemProp: "name",
    content: formatFullAddress(props)
  }), ___EmotionJSX("h2", {
    itemProp: "address",
    itemScope: true,
    itemType: "http://schema.org/PostalAddress",
    css: styles.scope
  }, renderLine1(), renderLine2()));
};
export default Address;